import {useTranslation} from 'react-i18next';
import ICON_KAKAO_WEBTOON_LIGHT from '../../../public/static/v4/404/icon-kw-logo-light-v4.svg';
import ICON_KAKAO_WEBTOON from '../../../public/static/v4/404/icon-kw-logo-v4.svg';
import IMG_NOT_FOUND_LIGHT from '../../../public/static/v4/404/img-not-found-light-v4.svg';
import IMG_NOT_FOUND from '../../../public/static/v4/404/img-not-found-v4.svg';
import Button from '../../common/component/Button';
import Text from '../../common/component/Text';
import {Page} from '../../common/constant/page';
import useTheme from '../../common/hook/useTheme';
import {routeTo} from '../../common/util/PageRouter';

export default function Error404V4() {
  const {isLightMode} = useTheme();
  const {t} = useTranslation();

  return (
    <div
      className="h-full flex-center"
      style={{paddingBottom: BTN_HEIGHT + BTN_PADDING_BOTTOM}}
    >
      <div className="flex-center flex-col">
        <img
          className="mt-12"
          src={isLightMode ? IMG_NOT_FOUND_LIGHT : IMG_NOT_FOUND}
          alt=""
        />
        <Text className="mt-20 s14-regular-white light:text-black">
          {t('error_page_not_found')}
        </Text>
      </div>
      <div
        className="w-full absolute px-9"
        style={{bottom: BTN_PADDING_BOTTOM}}
      >
        <Button
          className="w-full rounded-25 border border-white border-solid light:border-black"
          style={{
            height: BTN_HEIGHT,
          }}
          onClick={() => {
            routeTo({page: Page.Home});
          }}
        >
          <img
            src={isLightMode ? ICON_KAKAO_WEBTOON_LIGHT : ICON_KAKAO_WEBTOON}
            alt={t('common_service_name')}
          />
        </Button>
      </div>
    </div>
  );
}

const BTN_PADDING_BOTTOM = 30;
const BTN_HEIGHT = 50;
